import styles from "./Section.module.css";

export const Section = ({ children }: any) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.section}>{children}</div>
    </div>
  );
};
